import React, { FC } from 'react';
import { Page, StyleSheet, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { reportTextToPlainText } from '../../../../helpers/helpers';
import { IWorkEnvironmentData } from '../../../../services/individualReport';
import { THEME as theme } from '../../../../styles/theme';
import Legend from '../../components/Legend/Legend';
import PageCount from '../../components/PageCount/PageCount';
import PageSection from '../../components/PageSection/PageSection';
import SummaryList from '../../components/SummaryList/SummaryList';

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    fontFamily: 'Roboto-Regular',
    backgroundColor: theme.colors.neutral.secondary,
  },
});

interface IPerceivedWorkEnvironmentPage {
  mode: 'results' | 'group';
  workEnvironment: IWorkEnvironmentData;
}

const PerceivedWorkEnvironmentPage: FC<IPerceivedWorkEnvironmentPage> = ({
  mode,
  workEnvironment,
}) => {
  const { t } = useTranslation();

  const { description, categories, group_description } = workEnvironment;

  const parsedDescription = reportTextToPlainText(description);
  const parsedGroupDescription = reportTextToPlainText(group_description);

  return (
    <Page
      id="perceived-work-environment"
      orientation="portrait"
      size="A4"
      style={styles.page}
      wrap={false}
    >
      <PageSection title={t('results.report.pdf.sections.perceivedWorkEnvironment')}>
        <Text>{mode === 'group' ? parsedGroupDescription : parsedDescription}</Text>
        <Legend />
        <SummaryList data={categories} type="categories" {...{ mode }} />
      </PageSection>
      <PageCount />
    </Page>
  );
};

export default PerceivedWorkEnvironmentPage;
